import classNames from 'classnames';

import useNavigationHandler from '../../../hooks/useNavigationHandler/useNavigationHandler';

import { TEvent } from '../../../types/TGetEventsResponse';

import placeholderImage from '../../../images/placeholder.jpg';

import commons from '../../../shared/styles/common.module.scss';
import styles from './EventItem.module.scss';

type TProps = {
  event: TEvent;
};

const EventItem = ({ event }: TProps) => {
  const { createNavigationHandler } = useNavigationHandler();

  return (
    <div className={classNames(styles.eventContainer, commons.container)}>
      <div className={styles.eventContent}>
        <a
          key={event.id}
          href={String(event.id)}
          onClick={(e) => {
            e.preventDefault();
            createNavigationHandler(event.id, 'eventPage', ':eventId');
          }}
          className={styles.eventWrapper}>
          <div className={styles.eventText}>
            <h4 className={styles.eventTitle}>{event.title}</h4>
            {Object.values(event.dates).some((item) => item) && (
              <p className={styles.eventDate}>
                <span>{event.dates.start_date}</span>
                {event.dates.end_date && (
                  <>
                    <span>-</span>
                    {event.dates.end_date}
                  </>
                )}
              </p>
            )}
            <p className={styles.eventExcerpt}>{event.excerpt}</p>
          </div>
          <img
            src={event.featured_image || placeholderImage}
            alt={event.title}
            className={styles.eventImage}
          />
        </a>
      </div>
    </div>
  );
};

export default EventItem;
